module.exports = __webpack_public_path__ + "img/yjc.1d7e0b8a.svg";